import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
// components
import LoadingScreen from '../components/loading-screen';
import { useAuthContext } from './useAuthContext';
import Login from '../pages/public/Login';
import NoIndex from '../components/noindex/NoIndex';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuthContext();
  const navigate = useNavigate();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    // navigate('/login');

    return <Navigate to={`/login?returnTo=${encodeURIComponent(pathname)}`} replace />;
  } else {
    return <> <NoIndex>{children}</NoIndex></>;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

}
